/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type RdSAPAssessmentRatingBand = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

export const RdSAPAssessmentRatingBand = {
    A: 'A' as RdSAPAssessmentRatingBand,
    B: 'B' as RdSAPAssessmentRatingBand,
    C: 'C' as RdSAPAssessmentRatingBand,
    D: 'D' as RdSAPAssessmentRatingBand,
    E: 'E' as RdSAPAssessmentRatingBand,
    F: 'F' as RdSAPAssessmentRatingBand,
    G: 'G' as RdSAPAssessmentRatingBand
};

